export const TOLGEE_SETTINGS = {
  API_KEY: import.meta.env.VITE_APP_TOLGEE_API_KEY,
  API_URL: import.meta.env.VITE_APP_TOLGEE_API_URL,
  TRANSLATIONS_PREFIX:
    "https://storage.yandexcloud.net/i18n/2b8b7a6cc58f89fe656c44127511fe51",
  DEFAULT_LANGUAGE: "ru",
  AVAILABLE_LANGUAGES: ["ru", "en", "zh"],
  PROJECT_ID: 2,
};

export const PRODUCTS_SAMPLE_LIMIT = 10_000;
